import React, { useEffect, useState } from "react";
import DataTable from "MODULES/shared/components/DataTables/DataTable";
import api from "APP_ROOT/api";
import { dollar, percent } from "MODULES/shared/components/StatsTooltip/format";

export default () => {
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState([]);

  useEffect(() => {
    api.inventories.statsPerBuyer().then(({ data }) => {
      setResults(data);
      setLoading(false);
    });
    return function cleanup() {};
  }, []);

  const totalSrp = results.reduce(
    (total, row) => total + Number(row.total_srp_buyer_credit),
    0
  );

  const totalSellableSrp = results.reduce(
    (total, row) => total + Number(row.total_sellable_srp_buyer_credit),
    0
  );

  const totalPns = results.reduce(
    (total, row) => total + Number(row.total_pn_count),
    0
  );

  const totalUniquePns = results.reduce(
    (total, row) => total + Number(row.total_unique_pn_count),
    0
  );

  const totalCost = results.reduce(
    (total, row) => total + Number(row.total_buyer_credit),
    0
  );

  const totalSellableCost = results.reduce(
    (total, row) => total + Number(row.total_sellable_buyer_credit),
    0
  );

  const totalRow = {
    full_name: "Total",
    total_buyer_credit: totalCost,
    total_pn_count: totalPns,
    total_sellable_buyer_credit: totalSellableCost,
    total_sellable_srp_buyer_credit: totalSellableSrp,
    total_srp_buyer_credit: totalSrp,
    total_unique_pn_count: totalUniquePns
  };

  const getPercentOfCost = row =>
    percent(Number(row.total_buyer_credit) / Number(totalCost) * 100);

  const getProfitMargin = row =>
    percent(
      (Number(row.total_srp_buyer_credit) - Number(row.total_buyer_credit)) /
        Number(row.total_srp_buyer_credit) *
        100
    );

  return [
    <h2>Remaining Inventory Totals</h2>,
    <DataTable loading={loading}>
      <DataTable.Head>
        <th>Name</th>
        <th className="text-center">% Cost of Total Inventory</th>
        <th className="text-center">% Potential Profit Margin</th>
        <th className="text-center">Total PN Count</th>
        <th className="text-center">Total Unique PNs</th>
        <th className="text-right">Remaining Inventory Credit</th>
        <th className="text-center">Remaining Inventory Credit - Sellable</th>
        <th className="text-right">Remaining Inventory SRPs</th>
        <th className="text-center">Remaining Inventory SRPs - Sellable</th>
      </DataTable.Head>
      <DataTable.Body>
        {results &&
          results.concat(totalRow).map(r => (
            <tr>
              <td>{r.full_name}</td>
              <td className="text-center">{getPercentOfCost(r)}</td>
              <td className="text-center">{getProfitMargin(r)}</td>
              <td className="text-center">{r.total_pn_count}</td>
              <td className="text-right">{r.total_unique_pn_count}</td>
              <td className="text-right">{dollar(r.total_buyer_credit)}</td>
              <td className="text-center">
                {dollar(r.total_sellable_buyer_credit)}
              </td>
              <td className="text-right">{dollar(r.total_srp_buyer_credit)}</td>
              <td className="text-right">
                {dollar(r.total_sellable_srp_buyer_credit)}
              </td>
            </tr>
          ))}
      </DataTable.Body>
    </DataTable>
  ];
};



// WEBPACK FOOTER //
// ./app/modules/RemainingInventoryTotals/Table.jsx